(() => {

  const normalizeColor = (value) => {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };


  const initializeStory = (story) => {

    if (!story || story.dataset.colorStoryReady === 'true') return;

    story.dataset.colorStoryReady = 'true';


    const track = story.querySelector('[data-color-story-track]');

    const slides = Array.from(
      story.querySelectorAll('[data-color-story-slide]')
    );

    const dots = Array.from(
      story.querySelectorAll('[data-color-story-dot]')
    );

    const prev = story.querySelector('[data-color-story-prev]');
    const next = story.querySelector('[data-color-story-next]');

    const storyName =
      story.querySelector('[data-color-story-name]');


    const modal = story.querySelector('[data-color-story-modal]');

    const modalTrack = story.querySelector('[data-modal-track]');

    const modalSlides = Array.from(
      story.querySelectorAll('[data-modal-slide]')
    );

    const modalDots = Array.from(
      story.querySelectorAll('[data-modal-dot]')
    );

    const modalPrev = story.querySelector('[data-modal-prev]');
    const modalNext = story.querySelector('[data-modal-next]');

    const closeButton = story.querySelector('[data-color-story-close]');

    const expandButtons = Array.from(
      story.querySelectorAll('[data-color-story-expand]')
    );


    if (!track || !slides.length) return;


    const sectionId = story.dataset.sectionId;

    const productRoot =
      document.getElementById(`MainProduct-${sectionId}`) ||
      story.closest('product-info') ||
      story.closest('.product') ||
      document;


    let activeIndex = 0;
    let modalIndex = 0;

    let scrollTimer = null;
    let modalScrollTimer = null;
    let resizeTimer = null;
    let colorChangeTimer = null;


    /* =========================================
       SMALL CAROUSEL
       ========================================= */

    const getSlideCenterScrollLeft = (slide) => {

      if (!slide) {
        return track.scrollLeft;
      }


      const trackRect =
        track.getBoundingClientRect();

      const slideRect =
        slide.getBoundingClientRect();


      const trackCenter =
        trackRect.left +
        (trackRect.width / 2);


      const slideCenter =
        slideRect.left +
        (slideRect.width / 2);


      const requestedScroll =
        track.scrollLeft +
        (slideCenter - trackCenter);


      const maxScroll =
        Math.max(
          0,
          track.scrollWidth -
          track.clientWidth
        );


      return Math.max(
        0,
        Math.min(
          requestedScroll,
          maxScroll
        )
      );

    };


    const setActive = (index) => {

      activeIndex = Math.max(
        0,
        Math.min(
          index,
          slides.length - 1
        )
      );


      slides.forEach((slide, i) => {

        slide.classList.toggle(
          'is-selected',
          i === activeIndex
        );

        slide.classList.toggle(
          'is-prev',
          i === activeIndex - 1
        );

        slide.classList.toggle(
          'is-next',
          i === activeIndex + 1
        );

      });


      dots.forEach((dot, i) => {

        dot.classList.toggle(
          'is-active',
          i === activeIndex
        );


        if (i === activeIndex) {

          dot.setAttribute(
            'aria-current',
            'true'
          );

        } else {

          dot.removeAttribute(
            'aria-current'
          );

        }

      });


      if (prev) {
        prev.disabled = activeIndex === 0;
      }


      if (next) {

        next.disabled =
          activeIndex === slides.length - 1;

      }


      const activeSlide =
        slides[activeIndex];


      if (
        storyName &&
        activeSlide &&
        activeSlide.dataset.colorName
      ) {

        storyName.textContent =
          activeSlide.dataset.colorName;

      }

    };


    const scrollSmallTo = (
      index,
      behavior = 'smooth'
    ) => {

      const safeIndex =
        Math.max(
          0,
          Math.min(
            index,
            slides.length - 1
          )
        );


      const slide =
        slides[safeIndex];


      if (!slide) return;


      const target =
        getSlideCenterScrollLeft(slide);


      if (
        safeIndex === activeIndex &&
        Math.abs(track.scrollLeft - target) < 2
      ) {

        setActive(safeIndex);
        return;

      }


      track.scrollTo({
        left: target,
        behavior
      });


      setActive(safeIndex);

    };


    const scrollSmallToColor = (
      color,
      behavior = 'smooth'
    ) => {

      const wanted =
        normalizeColor(color);


      if (!wanted) return;


      const index =
        slides.findIndex((slide) => {

          return (
            normalizeColor(
              slide.dataset.color
            ) === wanted
          );

        });


      if (index >= 0) {

        scrollSmallTo(
          index,
          behavior
        );

      }

    };


    /* =========================================
       READ CURRENT PRODUCT COLOR
       ========================================= */

    const getSelectedColor = () => {

      const fieldsets =
        productRoot.querySelectorAll(
          'fieldset'
        );


      for (const fieldset of fieldsets) {

        const legend =
          fieldset.querySelector('legend');


        if (!legend) continue;


        const legendText =
          legend.textContent
            .replace(/\s+/g, ' ')
            .trim();


        if (!/colou?r/i.test(legendText)) {
          continue;
        }


        const checked =
          fieldset.querySelector(
            'input[type="radio"]:checked'
          );


        if (
          checked &&
          checked.value
        ) {

          return checked.value;

        }

      }


      const selects =
        productRoot.querySelectorAll(
          'select'
        );


      for (const select of selects) {

        const text = [
          select.name,
          select.id,
          select.getAttribute('aria-label')
        ]
          .filter(Boolean)
          .join(' ');


        if (
          /colou?r/i.test(text) &&
          select.value
        ) {

          return select.value;

        }

      }


      return '';

    };


    const syncProductColor = (
      behavior = 'smooth'
    ) => {

      const color =
        getSelectedColor();


      if (color) {

        scrollSmallToColor(
          color,
          behavior
        );

      }

    };


    /* =========================================
       PRODUCT COLOR CHANGES

       Only listen to the actual native change
       event. Do not listen to Dawn's additional
       variant lifecycle events, so one click
       creates one carousel movement.
       ========================================= */

    productRoot.addEventListener(
      'change',
      (event) => {

        const target =
          event.target;


        if (!target) return;


        let color = '';


        if (
          target.matches(
            'input[type="radio"]'
          )
        ) {

          const fieldset =
            target.closest('fieldset');


          const legend =
            fieldset
              ? fieldset.querySelector('legend')
              : null;


          const legendText =
            legend
              ? legend.textContent
                  .replace(/\s+/g, ' ')
                  .trim()
              : '';


          if (
            /colou?r/i.test(legendText)
          ) {

            color = target.value;

          }

        }


        if (
          !color &&
          target.matches('select')
        ) {

          const selectText = [
            target.name,
            target.id,
            target.getAttribute('aria-label')
          ]
            .filter(Boolean)
            .join(' ');


          if (
            /colou?r/i.test(selectText)
          ) {

            color = target.value;

          }

        }


        if (!color) return;


        clearTimeout(
          colorChangeTimer
        );


        /*
          The Color Story itself is now outside
          Dawn's variant picker redraw area, so
          we only need a very small delay before
          moving to the selected color.
        */

        colorChangeTimer =
          setTimeout(() => {

            requestAnimationFrame(() => {

              scrollSmallToColor(
                color,
                'smooth'
              );

            });

          }, 35);

      }
    );


    /* =========================================
       EXPANDED MODAL
       ========================================= */

    const setModalActive = (index) => {

      modalIndex = Math.max(
        0,
        Math.min(
          index,
          modalSlides.length - 1
        )
      );


      modalDots.forEach((dot, i) => {

        dot.classList.toggle(
          'is-active',
          i === modalIndex
        );


        if (i === modalIndex) {

          dot.setAttribute(
            'aria-current',
            'true'
          );

        } else {

          dot.removeAttribute(
            'aria-current'
          );

        }

      });


      if (modalPrev) {
        modalPrev.disabled = modalIndex === 0;
      }


      if (modalNext) {

        modalNext.disabled =
          modalIndex === modalSlides.length - 1;

      }

    };


    const scrollModalTo = (
      index,
      behavior = 'smooth'
    ) => {

      const safeIndex =
        Math.max(
          0,
          Math.min(
            index,
            modalSlides.length - 1
          )
        );


      const slide =
        modalSlides[safeIndex];


      if (
        !slide ||
        !modalTrack
      ) return;


      modalTrack.scrollTo({
        left:
          slide.offsetLeft -
          modalTrack.offsetLeft,

        behavior
      });


      setModalActive(
        safeIndex
      );

    };


    const openModal = (index) => {

      if (!modal) return;


      modalIndex = index;


      if (
        typeof modal.showModal ===
        'function'
      ) {

        modal.showModal();

      } else {

        modal.setAttribute(
          'open',
          ''
        );

      }


      requestAnimationFrame(() => {

        requestAnimationFrame(() => {

          scrollModalTo(
            index,
            'auto'
          );

        });

      });

    };


    const closeModal = () => {

      if (!modal) return;


      if (
        typeof modal.close ===
        'function'
      ) {

        modal.close();

      } else {

        modal.removeAttribute(
          'open'
        );

      }

    };


    /* =========================================
       IMAGE CLICKS
       ========================================= */

    expandButtons.forEach((button) => {

      button.addEventListener(
        'click',
        () => {

          const index =
            Number(
              button.dataset.index
            );


          if (
            !Number.isInteger(index)
          ) return;


          /*
            Side image:
            center it without changing product color.

            Center image:
            open the expanded Color Story.
          */

          if (index !== activeIndex) {

            scrollSmallTo(index);

            return;

          }


          openModal(index);

        }
      );

    });


    /* =========================================
       MODAL CONTROLS
       ========================================= */

    if (closeButton) {

      closeButton.addEventListener(
        'click',
        closeModal
      );

    }


    if (modalPrev) {

      modalPrev.addEventListener(
        'click',
        () => {

          scrollModalTo(
            modalIndex - 1
          );

        }
      );

    }


    if (modalNext) {

      modalNext.addEventListener(
        'click',
        () => {

          scrollModalTo(
            modalIndex + 1
          );

        }
      );

    }


    modalDots.forEach((dot) => {

      dot.addEventListener(
        'click',
        () => {

          const index =
            Number(
              dot.dataset.index
            );


          if (
            Number.isInteger(index)
          ) {

            scrollModalTo(index);

          }

        }
      );

    });


    if (modalTrack) {

      modalTrack.addEventListener(
        'scroll',
        () => {

          clearTimeout(
            modalScrollTimer
          );


          modalScrollTimer =
            setTimeout(() => {

              let closest = 0;
              let distance = Infinity;


              modalSlides.forEach(
                (slide, index) => {

                  const target =
                    slide.offsetLeft -
                    modalTrack.offsetLeft;


                  const diff =
                    Math.abs(
                      modalTrack.scrollLeft -
                      target
                    );


                  if (
                    diff < distance
                  ) {

                    distance = diff;
                    closest = index;

                  }

                }
              );


              setModalActive(
                closest
              );

            }, 80);

        },
        { passive: true }
      );

    }


    if (modal) {

      modal.addEventListener(
        'click',
        (event) => {

          if (
            event.target === modal
          ) {

            closeModal();

          }

        }
      );

    }


    /* =========================================
       SMALL CAROUSEL CONTROLS
       ========================================= */

    if (prev) {

      prev.addEventListener(
        'click',
        () => {

          scrollSmallTo(
            activeIndex - 1
          );

        }
      );

    }


    if (next) {

      next.addEventListener(
        'click',
        () => {

          scrollSmallTo(
            activeIndex + 1
          );

        }
      );

    }


    dots.forEach((dot) => {

      dot.addEventListener(
        'click',
        () => {

          const index =
            Number(
              dot.dataset.index
            );


          if (
            Number.isInteger(index)
          ) {

            scrollSmallTo(index);

          }

        }
      );

    });


    /* =========================================
       SWIPE / MANUAL SCROLL
       ========================================= */

    track.addEventListener(
      'scroll',
      () => {

        clearTimeout(scrollTimer);


        scrollTimer =
          setTimeout(() => {

            const trackRect =
              track.getBoundingClientRect();


            const trackCenter =
              trackRect.left +
              (trackRect.width / 2);


            let closest = 0;
            let distance = Infinity;


            slides.forEach(
              (slide, index) => {

                const slideRect =
                  slide.getBoundingClientRect();


                const slideCenter =
                  slideRect.left +
                  (slideRect.width / 2);


                const diff =
                  Math.abs(
                    trackCenter -
                    slideCenter
                  );


                if (
                  diff < distance
                ) {

                  distance = diff;
                  closest = index;

                }

              }
            );


            setActive(
              closest
            );

          }, 70);

      },
      { passive: true }
    );


    /* =========================================
       RESPONSIVE RECENTERING
       ========================================= */

    window.addEventListener(
      'resize',
      () => {

        clearTimeout(
          resizeTimer
        );


        resizeTimer =
          setTimeout(() => {

            scrollSmallTo(
              activeIndex,
              'auto'
            );

          }, 120);

      },
      { passive: true }
    );


    /* =========================================
       INITIAL POSITION
       ========================================= */

    const initialColor =
      story.dataset.initialColor;


    requestAnimationFrame(() => {

      requestAnimationFrame(() => {

        if (initialColor) {

          scrollSmallToColor(
            initialColor,
            'auto'
          );

        } else {

          syncProductColor(
            'auto'
          );

        }


        setActive(
          activeIndex
        );


        if (
          modalSlides.length
        ) {

          setModalActive(0);

        }

      });

    });

  };


  /* =========================================
     INITIALIZE
     ========================================= */

  const initializeAll = (
    root = document
  ) => {

    root
      .querySelectorAll(
        '[data-campair-color-story]'
      )
      .forEach(
        initializeStory
      );

  };


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () => {

        initializeAll();

      }
    );

  } else {

    initializeAll();

  }


  document.addEventListener(
    'shopify:section:load',
    (event) => {

      initializeAll(
        event.target
      );

    }
  );

})();
